import {
  GutBodyConnectionsColorVariant,
  GutBodyConnectionsOrgan,
} from '@repo/types';
import { GutBodyConnectionsOrganBadge, Typography } from '@repo/ui';
import styles from './OrganSelectorRow.module.css';

type OrganSelectorRowProps = {
  organ: GutBodyConnectionsOrgan;
  /** `kit.age_at_sampling`, in days. */
  age: number;
  pregnant: boolean;
  colorVariant?: GutBodyConnectionsColorVariant;
};

/** One organ as badge and name, shared by the selector's trigger and its list. */
export default function OrganSelectorRow({
  organ,
  age,
  pregnant,
  colorVariant,
}: OrganSelectorRowProps) {
  return (
    <span className={styles.row}>
      <GutBodyConnectionsOrganBadge
        organ={organ}
        age={age}
        pregnant={pregnant}
        colorVariant={colorVariant}
      />
      <Typography variant='body-s'>{organ.display_name}</Typography>
    </span>
  );
}
